import type { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { AppConfig } from '@src/config/AppConfig';

/**
 * Auth Provider - Presentation layer
 * Single Responsibility: Wraps app with Auth0 provider
 */
interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const config = AppConfig.getAuth0Config();

  return (
    <Auth0Provider
      domain={config.domain}
      clientId={config.clientId}
      authorizationParams={config.authorizationParams}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </Auth0Provider>
  );
};
